import * as Yup from "yup";

export const addRefereeSchema = Yup.object().shape({
  referralUserId: Yup.number().required("Referrer user ID is required"),
  refereeUserId: Yup.number().required("Referee user ID is required"),
});
